import { getAllTimezones } from 'countries-and-timezones'

const timeZones = Array.from({ length: 24 }, (_, i) => i - 11)

export function timezoneFormat(i: number) {
  const n = Math.abs(i)
  const nStr = n.toString().padStart(2, '0')
  const sign = i < 0 ? '-' : '+'
  return `UTC${sign}${nStr}:00`
}

export const timeZonesOptions = timeZones.map((i) => {
  const timezone = timezoneFormat(i)
  return {
    label: timezone,
    value: timezone,
  }
})

export function getComputerTimezone() {
  return new Date().getTimezoneOffset() / -60
}

export function getFormatedComputerTimezone() {
  return timezoneFormat(getComputerTimezone())
}

export const weekDayOptions = [
  { label: 'Sunday', value: 7 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
]

export const shortenWeekDayOptions = weekDayOptions.map(({ label, value }) => ({
  label: label.substring(0, 3),
  value,
}))

export enum FeatureTimezone {
  ReportTimezone,
  RegularTimezone,
  ComputerTimezone,
}

const timezoneNames = Object.values(getAllTimezones()).filter(({ name }) => name.startsWith('Etc/GMT'))
export const getTimezoneName = (timezone: string) => {
  return timezoneNames.find(({ utcOffsetStr }) => `UTC${utcOffsetStr}` === timezone)?.name || ''
}
